<template>
  <table class="wd-100p table table-bordered table-striped">
    <thead>
      <tr>
        <th>Д/д</th>
        <th>Огноо</th>
        <th>Хэрэглэгч</th>
        <th>Ном</th>
        <th>Төлөв</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(t, i) in tasks" :key="i">
        <td class="text-right tx-color-03">{{ ((page-1)*size) +(i + 1) }}</td>
        <td>{{ t.createdDate | moment("YYYY.MM.DD HH:mm") }}</td>
        <td>
          <span v-if="t.secondUser != null">{{ t.secondUser.fullName }}</span>
        </td>
        <td>
          <span v-if="t.organizationTask != null">{{
            t.organizationTask.task
          }}</span>{{ t.organizationTask.i1 }}
        </td>
        <td class="text-right pd-y-5 tx-12">
          <div v-if="t.i1 == 2">
            <span class="badge badge-success">Буцаан авсан</span>
            <div>{{ t.d2 | moment("YYYY.MM.DD HH:mm, dddd") }}</div>
          </div>
          <span v-else-if="t.i1 == -1" class="badge badge-secondary"
            >цуцалсан</span
          >
          <div v-if="t.i1 == 1" class="text-right">
            <span class="badge badge-warning">Баталгаажсан</span>
            <div class="mg-b-5">
              {{ t.d1 | moment("YYYY.MM.DD HH:mm, dddd") }}
            </div>
            <div class="d-flex wd-100p">
              <div v-if="t.i7==1">
                <a @click="$emit('on-extend', t)" class="tx-black" role="button">7 хоног сунгах хүсэлт ирсэн байна батлах бол 
                  <sapn class="tx-primary" style="font-size: 14px; font-weight: 500; text-decoration: underline">энд</sapn> дарна уу
                </a>
              </div>
              <a @click="$emit('on-giveback', t)" class="mg-l-auto text-uppercase link-01 bd pd-y-3 pd-x-5 rounded bg-white" role="button">
                <feather type="check"></feather>
                Хүлээж авах
              </a>
            </div>            
          </div>
          <div v-else-if="t.i1 == 0">
            <div>
              <div class="badge badge-success">шинэ захиалга</div>
            </div>
            <div class="btn-group mg-t-5">
              <button
                @click="$emit('on-decline', t)"
                class="btn btn-xs btn-danger"
              >
                Цуцлах
              </button>
              <button
                @click="$emit('on-accept', t)"
                class="btn btn-xs btn-success"
              >
                Батлах
              </button>
            </div>
          </div>
          <div v-else-if="t.i1 == -2">
            <div>
              <div class="badge badge-info">хүлээлгийн жагсаалт</div>
            </div>
            <div class="btn-group mg-t-5">
              <button
                @click="$emit('on-decline', t)"
                class="btn btn-xs btn-danger"
              >
                Цуцлах
              </button>
              <button
                @click="$emit('on-receipt', t)"
                class="btn btn-xs btn-info"
              >
                Хүсэлт батлах
              </button>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      default: () => 0
    },
    size: {
      type: Number,
      default: () => 0
    }
  }
};
</script>

<style></style>
